import Page from "components/Page";
import { lazyWithRetry } from "helpers/lazyWithRetry";
import { DashboardsProps } from "./Dashboards.types";

const Dashboards = lazyWithRetry(() => import("./DashboardsList"));

export default (props: DashboardsProps) => (
  <Page>
    <Dashboards {...props} />
  </Page>
);
